import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import { addNotification } from 'actions/NotificationsActions';

import MessageNew from 'components/modals/MessageNew';
import NoteNew from 'components/modals/NoteNew';
import TextMessageNew from 'components/modals/TextMessageNew';
import PasswordChange from 'components/modals/PasswordChange';

import may from 'js/security';

class ClientActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isActive: false,
      showNoteNew: false,
      showMessageNew: false,
      showPasswordChange: false,
      showTextMessageNew: false,
    };
  }

  showNoteNew = () => {
    this.props.actionExecuted('showNoteNew');
    this.setState({ showNoteNew: true, isActive: true });
  };

  closeNoteNew = () => {
    this.setState({ showNoteNew: false, isActive: false });
  };

  showMessageNew = () => {
    this.props.actionExecuted('showMessageNew');
    this.setState({ showMessageNew: true, isActive: true });
  };

  closeMessageNew = () => {
    this.setState({ showMessageNew: false, isActive: false });
  };

  showPasswordChange = () => {
    this.props.actionExecuted('showPasswordChange');
    this.setState({ showPasswordChange: true, isActive: true });
  };

  closePasswordChange = () => {
    this.setState({ showPasswordChange: false, isActive: false });
  };

  showTextMessageNew = () => {
    this.props.actionExecuted('showTextMessageNew');
    this.setState({ showTextMessageNew: true, isActive: true });
  };

  closeTextMessageNew = () => {
    this.setState({ showTextMessageNew: false, isActive: false });
  };

  componentDidUpdate = (prevProps, prevState) => {
    const {
      intl: { messages },
      newNoteFormStatus,
      passwordChangeFormStatus,
      newMessageFormStatus,
      newTextMessageFormStatus,
      doNotify,
    } = this.props;
    const { isActive } = this.state;

    if (isActive) {
      // note was saved to the client
      if (prevProps.newNoteFormStatus.pending && !newNoteFormStatus.pending && !newNoteFormStatus.hasError) {
        this.closeNoteNew();
        doNotify(1, messages.note_saved);
      }

      // new password was saved to the client
      if (
        prevProps.passwordChangeFormStatus.pending &&
        !passwordChangeFormStatus.pending &&
        !passwordChangeFormStatus.hasError
      ) {
        this.closePasswordChange();
        doNotify(1, messages.new_password_set);
      }

      // message was sent to the client
      if (prevProps.newMessageFormStatus.pending && !newMessageFormStatus.pending && !newMessageFormStatus.hasError) {
        this.closeMessageNew();
        doNotify(1, messages.message_sent);
      }

      // text message was sent to the client
      if (
        prevProps.newTextMessageFormStatus.pending &&
        !newTextMessageFormStatus.pending &&
        !newTextMessageFormStatus.hasError
      ) {
        this.closeTextMessageNew();
        doNotify(1, messages.text_message_sent);
      }
    }
  };

  getActions = () => {
    const { intl, client, user, listItemComponent } = this.props;
    const { messages } = intl;

    const actions = this.props.addActions.slice();
    const buttonProps = {
      block: true,
    };
/*
    if (true) {
      const buttonAction = this.showNoteNew;
      const icon = 'far fa-sticky-note';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={buttonAction} key="note-new">
            {messages.note}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, {
            ...buttonProps,
            action: buttonAction,
            caption: messages.note,
            icon,
            key: 'note-new',
          })
        )
      );
    }
*/
    if (client.profile && client.profile.email) {
      const buttonAction = this.showMessageNew;
      const icon = 'fa fa-paper-plane';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={buttonAction} key="message-new">
            {messages.send_message}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, {
            ...buttonProps,
            action: buttonAction,
            caption: messages.send_message,
            icon,
            key: 'message-new',
          })
        )
      );
    }
    /*
        if (client.profile && client.profile.mobile) {
          const buttonAction = this.showTextMessageNew;
          const icon = 'fas fa-mobile-android-alt';
          actions.push(
            listItemComponent === null ? (
              <Button {...buttonProps} onClick={buttonAction} key="text-message-new">
                {messages.send_text_message}
              </Button>
            ) : (
              React.cloneElement(listItemComponent, {
                ...buttonProps,
                action: buttonAction,
                caption: messages.send_text_message,
                icon,
                key: 'text-message-new',
              })
            )
          );
        }

        if (may('ROLE_CRM_PASSWORD', user.roles)) {
          const buttonAction = this.showPasswordChange;
          const icon = 'fas fa-key';
          actions.push(
            listItemComponent === null ? (
              <Button {...buttonProps} onClick={buttonAction} key="password-change">
                {messages.change_password}
              </Button>
            ) : (
              React.cloneElement(listItemComponent, {
                ...buttonProps,
                action: buttonAction,
                caption: messages.change_password,
                icon,
                key: 'password-change',
              })
            )
          );
        }
    */
    return actions;
  };

  render() {
    const { client, wrapperComponent } = this.props;

    const actions = this.getActions();
    const children = [...actions];

    children.push(
      <NoteNew client={client} show={this.state.showNoteNew} close={this.closeNoteNew} key="note-new-popup" />
    );

    children.push(
      <MessageNew
        client={client}
        show={this.state.showMessageNew}
        close={this.closeMessageNew}
        key="message-new-popup"
      />
    );

    children.push(
      <TextMessageNew
        client={client}
        show={this.state.showTextMessageNew}
        close={this.closeTextMessageNew}
        key="text-message-new-popup"
      />
    );

    children.push(
      <PasswordChange
        client={client}
        show={this.state.showPasswordChange}
        close={this.closePasswordChange}
        key="password-change-popup"
      />
    );

    if (wrapperComponent === null) {
      return children;
    }
    return React.cloneElement(wrapperComponent, {}, children);
  }
}
ClientActions.defaultProps = {
  wrapperComponent: <div />,
  listItemComponent: null,
  actionExecuted: () => {},
  addActions: [],
};

const mapStateToProps = state => {
  return {
    user: state.login.user,
    newMessageFormStatus: state.formStatus.messageNew,
    newNoteFormStatus: state.formStatus.noteNew,
    passwordChangeFormStatus: state.formStatus.passwordChange,
    newTextMessageFormStatus: state.formStatus.textMessageNew,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
  )(ClientActions),
  { forwardRef: true }
);
